import create from 'zustand';


const useStreamStore = create((set, get) => ({
  candles: {},
  orderBook: {},
  candlesBuffer: {},
  orderBookBuffer: {},
  

  updateCandles: (data) => set((state) => {
    const { exchange, instrument, candles } = data;
    // Sort the candles by time
    const sortedCandles = [...candles].sort((a, b) => a.time - b.time);
    return {
      candles: {
        ...state.candles,
        [exchange]: {
          ...state.candles[exchange],
          [instrument]: sortedCandles,
        },
      },
    };
  }),

  updateOrderBook: (data) => set((state) => {
    const { exchange, instrument, orderBook } = data;
    return {
      orderBook: {
        ...state.orderBook,
        [exchange]: {
          ...state.orderBook[exchange],
          [instrument]: orderBook,
        },
      },
    };
  }),

  // updateCandles: (data) => {
  //   const { exchange, instrument, candles } = data;
  //   console.log('excghange', exchange, instrument, candles)
  //   set((state) => ({
  //     candlesBuffer: {
  //       ...state.candlesBuffer,
  //       [exchange]: {
  //         ...state.candlesBuffer[exchange],
  //         [instrument]: candles,
  //       },
  //     },
  //   }));
  //   setTimeout(() => {
  //     set((state) => ({
  //       candles: {
  //         ...state.candles,
  //         ...state.candlesBuffer,
  //       },
  //       candlesBuffer: {},
  //     }));
  //   }, 1000); 
  // },
  
  // updateOrderBook: (data) => {
  //   const { exchange, instrument, orderBook } = data;
  //   set((state) => ({
  //     orderBookBuffer: {
  //       ...state.orderBookBuffer,
  //       [exchange]: {
  //         ...state.orderBookBuffer[exchange],
  //         [instrument]: orderBook,
  //       },
  //     },
  //   }));

  //   setTimeout(() => {
  //     set((state) => ({
  //       orderBook: {
  //         ...state.orderBook,
  //         ...state.orderBookBuffer,
  //       },
  //       orderBookBuffer: {}, 
  //     }));
  //   }, 1000);
  // },


}));

export default useStreamStore;